query WfaComponents(
	$runId: ConditionID!
	$offset: Int!
	$limit: Int!
	$sort: wfa_session_components_runsSort
	$textSearch: wfa_session_components_runsSearchInsensitive
	$urlFilter: ConditionString
	$severityIdFilter: ConditionString
	$typeIdFilter: ConditionString
	$levelFilter: ConditionString
) {
	wfa_session_components_runs(
		run_id_eq: $runId
		offset: $offset
		limit: $limit
		sort: $sort
		urls_eq_any_item: $urlFilter
		severity_names_eq_any_item: $severityIdFilter
		type_names_eq_any_item: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
	) {
		component_id
		total_issues
		total_pages
		type_names
	}
	total: wfa_session_components_runs(
		run_id_eq: $runId
		urls_eq_any_item: $urlFilter
		severity_names_eq_any_item: $severityIdFilter
		type_names_eq_any_item: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
	) {
		component_id_count
	}
	unfiltered_total: wfa_session_components_runs(run_id_eq: $runId) {
		component_id_count
	}
}
